import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClient, getBaseUrlVersioned } from "../../../services/axiosClient";
import { API_VERSION } from "../../types";
import { rememberMediaFiles } from "../../viewMedia/common/mediaFileCache";
import buildGetMediaFilesUrl from "./buildGetMediaFilesUrl";
const API_PATH_GALLERY = "gallery";
export const INVALID_MEDIA_FILES_RESPONSE_CODE = "INVALID_MEDIA_FILES_RESPONSE";
// A 200 with the wrong shape (a mock server, a proxy page) must fail like any other bad answer instead of poisoning the list.
const isMediaFilesPage = (payload) => typeof payload === "object" && payload !== null && Array.isArray(payload.items);
// One thunk serves both pages: omit `cursor` for the first page, pass the last `next_cursor` for the next one.
export const getMyMediaFiles = createAsyncThunk("gallery/getMyMediaFiles", async (params, thunkAPI) => {
    const baseUrl = `${getBaseUrlVersioned(API_VERSION.V1)}/${API_PATH_GALLERY}/my-files`;
    const apiUrl = buildGetMediaFilesUrl({ baseUrl, ...params });
    let page;
    try {
        const response = await axiosClient.get(apiUrl);
        page = response.data;
    }
    catch (error) {
        const responseBody = error?.response?.data;
        // No response body (network/timeout): rethrow so .unwrap() keeps Axios message/code.
        if (responseBody === undefined) {
            throw error;
        }
        throw thunkAPI.rejectWithValue(responseBody);
    }
    if (!isMediaFilesPage(page)) {
        throw thunkAPI.rejectWithValue({ message: "Unexpected media files response", errorCode: INVALID_MEDIA_FILES_RESPONSE_CODE });
    }
    // The grid now holds every file on this page, so opening one shows it at once instead of fetching it again.
    // Only a page the list itself accepts is remembered: leaving the gallery and returning leaves the first
    // request in flight, and a superseded answer the reducer discards must not stay behind in the cache.
    const { requestId } = thunkAPI;
    const { myGallery } = thunkAPI.getState();
    if (myGallery === undefined || myGallery.requestId === requestId) {
        rememberMediaFiles(page.items);
    }
    return page;
});
